import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue-demi';

interface Props {
  tabs: string[];
  initActiveTabIndex: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbTabs',
  props: {
    tabs: null,
    initActiveTabIndex: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', index: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tabs: string[];
  initActiveTabIndex: number;
};




const abTabsRef = ref();
const activeTabIndex = ref(props.initActiveTabIndex || 0);

const placeActiveTabInCenter = (activeIndex: number) => {
  const tabs = abTabsRef.value;
  if (!tabs) return;

  const navButton = tabs.children[activeIndex] as HTMLElement;
  if (!navButton) return;

  const parent = tabs.parentElement!;
  const parentWidth = parent.clientWidth;
  const buttonOffset = navButton.offsetLeft;
  const buttonWidth = navButton.offsetWidth;

  const scrollTo = buttonOffset - parentWidth / 2 + buttonWidth / 2;

  parent.scroll({
    left: scrollTo,
  });
};

const changeTab = (index: number) => {
  activeTabIndex.value = index;

  placeActiveTabInCenter(index);
  emit('change', index);
};

return { __sfc: true,emit, props, abTabsRef, activeTabIndex, placeActiveTabInCenter, changeTab }
}

})